import {
  ArrowDownToDot, Building, Building2, Briefcase, CloudHail, Fingerprint, HardHat, House,
  Laptop, Package, ShieldCheck, Tornado, TrendingUp, Umbrella, Users, Waves, Wind, Wine, Zap,
} from "lucide-react";

const MAP = {
  ArrowDownToDot, Building, Building2, Briefcase, CloudHail, Fingerprint, HardHat, House,
  Laptop, Package, ShieldCheck, Tornado, TrendingUp, Umbrella, Users, Waves, Wind, Wine, Zap,
};

export default function ProgramIcon({ name, className = "h-5 w-5" }) {
  const Icon = MAP[name] || ShieldCheck;
  return <Icon className={className} aria-hidden="true" />;
}
